function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 19"
}, props), React.createElement("path", {
  d: "M9.5 19c-.385 0-.707-.13-.968-.39-.26-.261-.39-.584-.39-.967v-6.786H1.358c-.384 0-.707-.13-.967-.39C.129 10.205 0 9.883 0 9.5c0-.385.13-.707.39-.968.261-.26.584-.39.967-.39h6.786V1.358c0-.384.13-.707.39-.967C8.795.129 9.117 0 9.5 0c.385 0 .707.13.968.39.26.261.39.584.39.967v6.786h6.785c.384 0 .707.13.967.39.261.261.39.583.39.967 0 .385-.13.707-.39.968-.261.26-.584.39-.967.39h-6.786v6.785c0 .384-.13.707-.39.967-.261.261-.583.39-.967.39z",
  fill: "#959595"
})));